import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import type { TablePricingManagerContextColumn } from 'lumen/components/hotel/pricing-assistant/table/table-pricing-manager';
import type { Period } from 'lumen/models';
import { formatOverbookingValue } from 'lumen/utils/pricing-assistant/restriction-display-utils';

interface HotelPricingAssistantTableCellsTdHotelOverbookingMonthSignature {
  Args: {
    column: TablePricingManagerContextColumn;
    row: { period: Period };
  };
}

export default class HotelPricingAssistantTableCellsTdHotelOverbookingMonth extends Component<HotelPricingAssistantTableCellsTdHotelOverbookingMonthSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare intl: Services['intl'];

  get displayValue(): number | string {
    return formatOverbookingValue({
      intl: this.intl,
      value: this.args.row.period.effectiveOverbookingWithOverride,
    });
  }

  get isLoading(): boolean {
    return this.args.row.period.hasOverbookingActionInProgress;
  }

  get isMissing(): boolean {
    return this.args.row.period.effectiveOverbookingWithOverride == null;
  }

  get isPast(): boolean {
    return this.hotelAndMarketService.isPast(this.args.row.period.fromDate);
  }

  <template>
    {{#if this.isLoading}}
      <div class="loading-pulse" data-test-id="loading-pulse"></div>
    {{else}}
      <div
        class="mr-500
          {{if
            this.isPast
            'text-disabled'
            (if this.isMissing 'text-neutral-subdued')
          }}"
        data-test-id="td-hotel-overbooking-month"
      >
        {{this.displayValue}}
      </div>
    {{/if}}
  </template>
}
